import React from 'react'
import { createRoot } from 'react-dom/client'

import WidgetApp from 'WidgetApp'

import SimpleCtaApp from './App'

const root = createRoot(document.getElementById('root'))

root.render(
  <WidgetApp>
    <SimpleCtaApp />
  </WidgetApp>,
)
